import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import {
	Banner,
	StyledTypography,
	StyledContainer,
	StyledLink
} from './styles';
import { AcceptCookieButton } from '../Buttons';
import CookiesPolicyES from '../../assets/pdf/es/cookiesPolicy.pdf';
import CookiesPolicyEN from '../../assets/pdf/en/cookiesPolicy.pdf';
import { checkCookie, setCookie } from '../../services/CookieManager';

const CookiesBanner = () => {
	const [show, setShow] = useState(checkCookie('accepted') !== 'true');
	const { i18n } = useTranslation();

	const cookiesPolicyLink =
		i18n.language === 'es' ? CookiesPolicyES : CookiesPolicyEN;

	return (
		<Banner display={show ? 'block' : 'none'}>
			<StyledContainer>
				<StyledTypography paragraph color="textPrimary">
					<Trans
						i18nKey="legalWarning.cookies.text"
						components={[
							<StyledLink
								key="cookies-policy"
								href={cookiesPolicyLink}
								color="textPrimary"
								target="_blank"
								underline="always"
								rel="noopener noreferrer"
							/>
						]}
					/>
				</StyledTypography>

				<AcceptCookieButton
					handlerClick={() => {
						setCookie('accepted', 'true');
						try {
							window.dispatchEvent(
								new CustomEvent('cookiesAccepted')
							);
						} catch (e) {}
						setShow(false);
					}}
				/>
			</StyledContainer>
		</Banner>
	);
};

export default CookiesBanner;
